interface Props {
  icon: React.ReactNode;
  title: string;
  color: string;
}

export const Item = (props: Props) => {
  return (
    <div
      css={`
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;

        @media (min-width: 960px) {
          gap: 32px;
        }
      `}
    >
      <div
        css={`
          border-radius: 70px;
          width: 140px;
          height: 140px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: ${props.color};
        `}
      >
        {props.icon}
      </div>
      <div
        css={`
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          font-family: "Pretendard", sans-serif;
          line-height: 30px;
          text-align: center;

          @media (min-width: 960px) {
            line-height: 33.986px;
            font-size: 24px;
          }
        `}
      >
        {props.title}
      </div>
    </div>
  );
};
